import { useMemo } from 'react';
import useWindowDimensions from './useWindowDimensions';
import { KLYDO_HEIGHT_WITHOUT_FRAME } from '../consts/clockDimensions';

const useKlydoScale = (): number => {
  const { height: windowHeight } = useWindowDimensions();

  const scale = useMemo(() => {
    const targetHeight = windowHeight * 0.87;
    const calculatedScale = targetHeight / KLYDO_HEIGHT_WITHOUT_FRAME;

    return Math.min(Math.max(calculatedScale, 0), 1);
  }, [windowHeight]);

  return scale;
};

export default useKlydoScale;
